import React from 'react';
import * as S from './styles';

interface RowProps {
    label: React.ReactNode;
    value: React.ReactNode;
    color: string;
}

const Row = ({ label, value, color }: RowProps) => (
    <S.Row>
        <S.Label>{label}</S.Label>
        <S.Value $color={color}>{value}</S.Value>
    </S.Row>
);

const Divider = () => <S.Divider />;

interface DataCardProps {
    children: React.ReactNode;
}

const Root = ({ children }: DataCardProps) => (
    <S.Container>{children}</S.Container>
);

export const DataCard = {
    Root,
    Row,
    Divider,
};